import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import initialState from "./recipe.store";
import { loadRecipeSuccessful, setDisplayMode, setRecipeBuilderActionMode, addRecipeStepSuccessful, removeRecipeStepsSuccessful, getRecipeStepsListSuccessful, updateStepSuccessful, loadGasNamesSuccessful, loadLiquidNamesSuccessful, loadParameterNamesSuccessful, upsertLiquidSuccessful, upsertParameterSuccessful, upsertGasSuccessful, setEditableParameter, deleteParameterSuccessful, deleteLiquidSuccessful, deleteGasSuccessful, addRecipeCustomVariableSuccessful, editRecipeCustomVariableSuccessful, setPlusIconPlacement, concurrentStepSetFlowMustCompeteSuccessful, getRecipeCustomVariableDefaultNameSuccessful, getCustomVariableTransformationsSuccessful, getRecipeCustomVariableFormulaStatusSuccessful, setRecipeCustomVariableFormulaStatus, conditionalStepUpdateFlowSuccessful, complexStepAddFlowSuccessful, complexStepDeleteFlowSuccessful, complexStepMoveFlowSuccessful, setSelectedStepIds, moveRecipeStepsSuccessful, deleteRecipeCustomVariableSuccessful, loopStepUpdateConditionSuccessful, addWrapStepSuccessful, loadAlternativeStepNamesSuccessful, alternativeStepSetActiveFlow, alternativeStepChangeDefaultFlowSuccessful, updateAlternativeStepSuccessful, removeAlternativeStepSuccessful, setRecipeDialogStatesSuccess, } from "./recipe.actions";
import { reset } from "store/knowledge-base-item/knowledge-base-item.actions";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(reset, () => initialState)
        .addCase(loadRecipeSuccessful, (state, { payload }) => {
        state.inUse = payload.inUse === undefined ? state.inUse : payload.inUse;
        if (payload.state !== null) {
            const steps = payload.state.steps;
            state.state = payload.state;
            state.plusIconPlacement = { previousStepId: steps[steps.length - 1]?.id };
        }
    })
        .addCase(getRecipeStepsListSuccessful, (state, { payload }) => {
        state.stepsList = payload?.categories;
    })
        .addCase(setSelectedStepIds, (state, { payload }) => {
        state.selectedStepIds = payload;
    })
        .addCase(setDisplayMode, (state, { payload }) => {
        state.mode = payload;
    })
        .addCase(setRecipeBuilderActionMode, (state, { payload }) => {
        state.recipeBuilderActionMode = payload;
    })
        .addCase(addWrapStepSuccessful, (state, { payload }) => {
        state.state = payload;
        state.selectedStepIds = [];
    })
        .addCase(setPlusIconPlacement, (state, { payload }) => {
        state.plusIconPlacement = payload;
    })
        .addCase(updateStepSuccessful, (state, { payload }) => {
        state.state = payload;
        state.dialogs.step = { isOpen: false };
    })
        .addCase(conditionalStepUpdateFlowSuccessful, (state, { payload }) => {
        state.state = payload;
        state.dialogs.conditionalFlow = { isOpen: false };
    })
        .addCase(loopStepUpdateConditionSuccessful, (state, { payload }) => {
        state.state = payload;
        state.dialogs.step = { isOpen: false };
    })
        .addCase(alternativeStepSetActiveFlow, (state, { payload }) => {
        state.alternativeStepActiveFlows = {
            ...state.alternativeStepActiveFlows,
            ...payload.payload,
        };
        if (payload.plusIconPlacement) {
            state.plusIconPlacement = payload.plusIconPlacement;
        }
    })
        .addCase(setRecipeDialogStatesSuccess, (state, { payload }) => {
        state.dialogs = {
            ...state.dialogs,
            ...payload,
        };
    })
        .addCase(loadAlternativeStepNamesSuccessful, (state, { payload }) => {
        state.alternativeStepNames = payload;
    })
        .addCase(loadGasNamesSuccessful, (state, { payload }) => {
        state.gasNames = payload;
    })
        .addCase(loadLiquidNamesSuccessful, (state, { payload }) => {
        state.liquidNames = payload;
    })
        .addCase(loadParameterNamesSuccessful, (state, { payload }) => {
        state.parameterNames = payload;
    })
        .addCase(upsertGasSuccessful, (state, { payload }) => {
        state.state = payload;
        state.dialogs.gas = { isOpen: false };
    })
        .addCase(upsertLiquidSuccessful, (state, { payload }) => {
        state.state = payload;
        state.dialogs.liquid = { isOpen: false };
    })
        .addCase(setEditableParameter, (state, { payload }) => {
        state.editableParameter = payload;
    })
        .addCase(upsertParameterSuccessful, (state, { payload }) => {
        state.state = payload;
        state.editableParameter = undefined;
    })
        .addCase(getRecipeCustomVariableDefaultNameSuccessful, (state, { payload }) => {
        state.customVariableDefaultName = payload;
    })
        .addCase(getCustomVariableTransformationsSuccessful, (state, { payload }) => {
        state.customVariableTransformations = payload;
    })
        .addMatcher(isAnyOf(setRecipeCustomVariableFormulaStatus, getRecipeCustomVariableFormulaStatusSuccessful), (state, { payload }) => {
        state.currentCustomVariableFormulaStatus = payload;
    })
        .addMatcher(isAnyOf(addRecipeCustomVariableSuccessful, editRecipeCustomVariableSuccessful), (state, { payload }) => {
        state.state = payload;
        state.dialogs.customVariable = { isOpen: false };
        state.currentCustomVariableFormulaStatus = null;
    })
        .addMatcher(isAnyOf(addRecipeStepSuccessful, moveRecipeStepsSuccessful, complexStepAddFlowSuccessful, complexStepDeleteFlowSuccessful, complexStepMoveFlowSuccessful, concurrentStepSetFlowMustCompeteSuccessful, alternativeStepChangeDefaultFlowSuccessful, updateAlternativeStepSuccessful, removeAlternativeStepSuccessful, deleteGasSuccessful, deleteLiquidSuccessful, deleteParameterSuccessful, removeRecipeStepsSuccessful, deleteRecipeCustomVariableSuccessful), (state, { payload }) => {
        state.state = payload;
    });
});
